import { UPDATE_HBS_PROPERTIES } from "../../reducers/hbs/hbsReducer";
import { Urls } from "../../constants/UrlConstants";

export const updateHbsProperties = props => {
  return {
    type: UPDATE_HBS_PROPERTIES,
    payload: props
  };
};

export const setVirtualLucyUrl = history => {
  return async (dispatch, getState) => {
    window.open(Urls.HbsLink);   
};

};
